/**
 * Formats a date string to dd.MM.yyyy format
 * @param dateString - ISO date string or any valid date string
 * @returns Formatted date string in dd.MM.yyyy format
 */
export const formatDate = (dateString: string | Date): string => {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
